export const SAVE_PROPOSAL = 'ideal/components/Quotation/SAVE_PROPOSAL';
export const SAVE_QUOTATION = 'ideal/components/Quotation/SAVE_QUOTATION';
export const SAVE_QUOTATION_SUCCESS = 'ideal/components/Quotation/SAVE_QUOTATION_SUCCESS';
export const SAVE_QUOTATION_ERROR = 'ideal/components/Quotation/SAVE_QUOTATION_ERROR';
export const SAVE_PROPOSAL_SUCCESS = 'ideal/components/Quotation/SAVE_PROPOSAL_SUCCESS';
export const SAVE_PROPOSAL_ERROR = 'ideal/components/Quotation/SAVE_PROPOSAL_ERROR';
export const UPDATE_QUOTATION = 'ideal/components/Quotation/UPDATE_QUOTATION';
export const SEARCH_CUSTOMER_BY_FISCAL = 'ideal/components/Quotation/SEARCH_CUSTOMER_BY_FISCAL';
export const SEARCH_CUSTOMER_BY_VAT = 'ideal/components/Quotation/SEARCH_CUSTOMER_BY_VAT';
export const CUSTOMER_RECEIVED = 'ideal/components/Quotation/CUSTOMER_RECEIVED';
export const CUSTOMER_FOUND = 'ideal/components/Quotation/CUSTOMER_FOUND';
export const UPDATE_CUSTOMER_INPUT = 'ideal/components/Quotation/UPDATE_CUSTOMER_INPUT';
export const RESET_CUSTOMER = 'ideal/components/Quotation/RESET_CUSTOMER';
export const SET_UPDATED = 'ideal/components/Quotation/SET_UPDATED';
export const PRINT_QUOTATION = 'ideal/components/quotationSidebar/PRINT_QUOTATION';
